export default __webpack_public_path__ + "static/media/roadmap_5.53f94d20.png";